/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import pluralize from 'cio/utils/pluralize';
import SegmentModel from 'cio/models/segment';

interface SegmentsListArgs {
  segment: SegmentModel;
}

export default class Audiences extends Component<SegmentsListArgs> {
  @computed('args.segment.audiences.length')
  get tooltipContent() {
    let {
      segment: { audiences },
    } = this.args;

    return `${audiences.length} ${pluralize(audiences.length as number, 'Ad Audience')} total`;
  }
}
